import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useRef, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken } from "views/utils/CallApi";
import { postApiDataWithToken } from "views/utils/CallApi";
import * as mb from "views/common/MessageBox";
import * as Validation from "views/utils/Validation";

import { CtxAuth } from "views/utils/Contexts";
import { getRef } from "views/utils/InputHelp";

interface IFCompanyHistory {
    companyName: string,
    companyMailAddress: string,
    companyAddress: string,
    companyZipCode: string,
    companyTel: string
}

export function Company(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [companyHistory, setCompanyHistory] = useState<IFCompanyHistory[]>();
    const companyName = useRef<HTMLInputElement>(null);
    const companyMailAddress = useRef<HTMLInputElement>(null);
    const companyAddress = useRef<HTMLInputElement>(null);
    const companyTel = useRef<HTMLInputElement>(null);
    const companyZipCode = useRef<HTMLInputElement>(null);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);

    function clickSubmit(){
        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true);

        //バリデーションチェック
        let errmsg:string;
        //会社名入力チェック
        errmsg = Validation.checkEmptyTextBox(getRef(companyName), "会社名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(companyName), 200, "会社名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //メールアドレス入力チェック
        errmsg = Validation.checkEmptyTextBox(getRef(companyMailAddress), "メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(companyMailAddress), 256, "メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkMailRule(getRef(companyMailAddress), "メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //郵便番号入力チェック
        errmsg = Validation.checkEmptyTextBox(getRef(companyZipCode), "郵便番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkZipCodeRule(getRef(companyZipCode), "郵便番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //住所入力チェック
        errmsg = Validation.checkEmptyTextBox(getRef(companyAddress), "住所")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(companyAddress), 256, "住所")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //電話番号入力チェック
        errmsg = Validation.checkEmptyTextBox(getRef(companyTel), "電話番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkTelNumberRule(getRef(companyTel), "電話番号")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //入力値取得
        postApiDataWithToken('/management/settings/company',
            {'company_name': getRef(companyName), 'company_mail_address': getRef(companyMailAddress), 'company_address': getRef(companyAddress), 'company_tel': getRef(companyTel), 'company_zip_code': getRef(companyZipCode)},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"会社設定が完了しました。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"会社設定に失敗しました。"});
                }
                //ボタンを活性にする
                setSubmitDisabled(false);
            }
        );
    }

    useEffect(function(){       

        //初期値取得
        const cpHistory:IFCompanyHistory[] = [];

        getApiDataWithToken('/management/settings/system',
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        cpHistory.push({companyName:res.data.system_list[0].company_name, companyMailAddress:res.data.system_list[0].company_mail_address, companyAddress:res.data.system_list[0].company_address, companyZipCode:res.data.system_list[0].company_zip_code, companyTel:res.data.system_list[0].company_tel});
                        setCompanyHistory(cpHistory);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs}/>
                <h2 className="settings-title-h2">会社設定</h2>
                <div className="settings-wrap-short">
                    <div className="settings-block">
                        <h3 className="settings-title-h3">会社情報</h3>
                        {companyHistory?.map(function(val, idx){
                            return(
                                <div className="settings-form" key={idx}>
                                    <div className="form-row">
                                        <div className="form-row-title">会社名</div>
                                        <div className="form-row-input"><input required type="text" ref={companyName} defaultValue={val.companyName}/></div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-row-title">メールアドレス</div>
                                        <div className="form-row-input"><input required type="text" ref={companyMailAddress} defaultValue={val.companyMailAddress}/></div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-row-title">郵便番号</div>
                                        <div className="form-row-input"><input required type="text" className="input-size-s" placeholder="000-0000" ref={companyZipCode} defaultValue={val.companyZipCode}/></div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-row-title">住所</div>
                                        <div className="form-row-input"><input required type="text" ref={companyAddress} defaultValue={val.companyAddress}/></div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-row-title">電話番号</div>
                                        <div className="form-row-input"><input required type="text" ref={companyTel} defaultValue={val.companyTel}/></div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <button className="btn-primary margin-tb-20" onClick={clickSubmit} disabled={submitDisabled}>変更を保存</button>
                </div>
            </div>
        </AdminFrame>
    )
}